import { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ReportEntryCard } from './ReportEntryCard';
import { ReportEntryForm } from './ReportEntryForm';

export const ReportSection = ({ config, entries, today, onSave, onAction }) => {
  const [editor, setEditor] = useState(null);
  const { tipo, title, icon: Icon, color, empty } = config;
  const prefix = `report-section-${tipo.toLowerCase()}`;
  const save = async (values) => {
    await onSave(editor?.id, values);
    setEditor(null);
  };
  const renderEntry = (entry) => editor?.id === entry.id
    ? <ReportEntryForm key={entry.id} tipo={tipo} entry={entry} today={today} onSave={save} onCancel={() => setEditor(null)} />
    : <ReportEntryCard key={entry.id} entry={entry} color={color} onEdit={setEditor} onAction={onAction} />;
  const areas = [...new Set(entries.map((entry) => entry.area))].sort((a, b) => a.localeCompare(b, 'it'));

  return (
    <section data-testid={prefix} aria-labelledby={`${prefix}-title`} className={`min-w-0 border-t pt-6 ${tipo === 'CONTROLLO' ? 'border-fuchsia-200' : 'border-gray-200'}`}>
      <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-2 sm:gap-3">
          <Icon className="h-5 w-5 shrink-0" style={{ color }} />
          <h3 id={`${prefix}-title`} data-testid={`${prefix}-title`} className="text-base font-semibold text-gray-900 sm:text-lg">{title}</h3>
          <span data-testid={`${prefix}-count`} className="text-sm font-semibold" style={{ color }}>{entries.length}</span>
        </div>
        <Button variant="outline" size="sm" data-testid={`${prefix}-add`} onClick={() => setEditor({})} disabled={editor !== null} className="gap-1.5 bg-white"><Plus className="h-4 w-4" />Aggiungi</Button>
      </div>
      {editor && !editor.id && <div className="mb-5"><ReportEntryForm tipo={tipo} today={today} onSave={save} onCancel={() => setEditor(null)} /></div>}
      {entries.length === 0 && <p data-testid={`${prefix}-empty`} className="py-3 text-sm text-gray-500">{empty}</p>}
      {tipo === 'FEATURE' ? areas.map((area, index) => <div key={area} className="mb-6">
        <h4 data-testid={`${prefix}-area-${index}`} className="mb-3 text-sm font-semibold text-gray-600">{area}</h4>
        <div className="grid min-w-0 grid-cols-1 gap-4 lg:grid-cols-2">{entries.filter((entry) => entry.area === area).map(renderEntry)}</div>
      </div>) : <div className="grid min-w-0 grid-cols-1 gap-4 lg:grid-cols-2">{entries.map(renderEntry)}</div>}
    </section>
  );
};